import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '实现者',
    type: 'RULE_IMPLEMENTER',
}
